export function renderCurrentlyBuilding() {
  return `
    <section id="currently-building" class="cv-auto py-20 md:py-28 px-6 lg:px-16 bg-[#050505] bg-tech-grid relative border-b border-[#1C201E]">
      <div class="max-w-7xl mx-auto">
        <!-- Section Header Info -->
        <div class="flex flex-wrap items-center justify-between border-b border-[#1C201E] pb-4 mb-12 font-mono text-xs text-neutral-400 uppercase tracking-widest">
          <div class="flex items-center gap-3">
            <span class="px-2.5 py-0.5 border border-white/20 text-neutral-200">04 / CURRENTLY BUILDING</span>
            <span class="text-white font-medium">RESEARCH TRAJECTORY &amp; ROADMAP</span>
          </div>
          <div class="tracking-widest hidden sm:block text-neutral-400 text-[11px]">
            LEARNING → EXPLORING → BUILDING
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-12">
          <div class="md:col-span-8">
            <h2 class="text-4xl sm:text-6xl font-bold tracking-tighter text-[#FAF8F5] font-display">
              <span class="sr-only">Active Research &amp; Current Developments — </span>Curiosity in <span class="font-serif italic font-normal text-amber-100">execution.</span>
            </h2>
          </div>
          <div class="md:col-span-4">
            <p class="font-mono text-xs text-neutral-400 leading-relaxed font-light">
              A transparent view into active focus areas: what I am studying, the frontiers I am investigating, and the things currently taking shape.
            </p>
          </div>
        </div>

        <!-- 3-Column Blueprint Table -->
        <div class="border border-[#1C201E] divide-y md:divide-y-0 md:divide-x divide-[#1C201E] bg-[#0E100F]/70 grid grid-cols-1 md:grid-cols-3 font-mono">
          
          <!-- Column 01: LEARNING -->
          <div class="p-6 sm:p-8 space-y-4">
            <div class="flex justify-between items-center pb-3 border-b border-[#1C201E]">
              <span class="text-xs font-bold text-neutral-400 uppercase tracking-wider">01 // LEARNING</span>
              <span class="w-1.5 h-1.5 rounded-full bg-cyan-telemetry"></span>
            </div>
            <span class="text-[10px] text-neutral-500 uppercase block tracking-widest">FOUNDATIONAL DISCIPLINES</span>
            <ul class="space-y-2.5 text-xs text-neutral-200 font-light">
              <li class="flex items-center gap-2">
                <span class="text-neutral-600">▪</span>
                <span>Computer Science</span>
              </li>
              <li class="flex items-center gap-2">
                <span class="text-neutral-600">▪</span>
                <span>Mathematics</span>
              </li>
              <li class="flex items-center gap-2">
                <span class="text-neutral-600">▪</span>
                <span>Physics</span>
              </li>
              <li class="flex items-center gap-2">
                <span class="text-neutral-600">▪</span>
                <span>Algorithms &amp; Complexity</span>
              </li>
              <li class="flex items-center gap-2">
                <span class="text-neutral-600">▪</span>
                <span>Computer Graphics</span>
              </li>
              <li class="flex items-center gap-2">
                <span class="text-neutral-600">▪</span>
                <span>Software Engineering</span>
              </li>
            </ul>
          </div>

          <!-- Column 02: EXPLORING -->
          <div class="p-6 sm:p-8 space-y-4">
            <div class="flex justify-between items-center pb-3 border-b border-[#1C201E]">
              <span class="text-xs font-bold text-neutral-400 uppercase tracking-wider">02 // EXPLORING</span>
              <span class="w-1.5 h-1.5 rounded-full bg-amber-400"></span>
            </div>
            <span class="text-[10px] text-neutral-500 uppercase block tracking-widest">CREATIVE &amp; COMPUTATIONAL FRONTIERS</span>
            <ul class="space-y-2.5 text-xs text-neutral-200 font-light">
              <li class="flex items-center gap-2">
                <span class="text-neutral-600">▪</span>
                <span>WebGL &amp; WebGPU</span>
              </li>
              <li class="flex items-center gap-2">
                <span class="text-neutral-600">▪</span>
                <span>Shaders (GLSL)</span>
              </li>
              <li class="flex items-center gap-2">
                <span class="text-neutral-600">▪</span>
                <span>3D Graphics</span>
              </li>
              <li class="flex items-center gap-2">
                <span class="text-neutral-600">▪</span>
                <span>Game Development (Godot)</span>
              </li>
              <li class="flex items-center gap-2">
                <span class="text-neutral-600">▪</span>
                <span>Systems Programming</span>
              </li>
              <li class="flex items-center gap-2">
                <span class="text-neutral-600">▪</span>
                <span>Desktop Applications</span>
              </li>
            </ul>
          </div>

          <!-- Column 03: BUILDING -->
          <div class="p-6 sm:p-8 space-y-4">
            <div class="flex justify-between items-center pb-3 border-b border-[#1C201E]">
              <span class="text-xs font-bold text-neutral-400 uppercase tracking-wider">03 // BUILDING</span>
              <span class="w-1.5 h-1.5 rounded-full bg-emerald-400 terminal-beacon-green"></span>
            </div>
            <span class="text-[10px] text-neutral-500 uppercase block tracking-widest">ACTIVE ARTIFACTS</span>
            <ul class="space-y-2.5 text-xs text-neutral-200 font-light">
              <li class="flex items-center gap-2">
                <span class="text-emerald-400">✔</span>
                <span>Software Systems</span>
              </li>
              <li class="flex items-center gap-2">
                <span class="text-emerald-400">✔</span>
                <span>Interactive Visual Experiments</span>
              </li>
              <li class="flex items-center gap-2">
                <span class="text-emerald-400">✔</span>
                <span>Gameplay &amp; Physics Prototypes</span>
              </li>
              <li class="flex items-center gap-2 pt-2 border-t border-[#1C201E]">
                <span class="text-amber-300">✦</span>
                <span class="font-serif italic text-amber-100 font-normal text-sm">Things I haven't figured out yet.</span>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </section>
  `;
}
